export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "topics",
    method: "post",
    body: payload
  });

  return await response.json();
};
